module.exports = __webpack_public_path__ + "static/media/bigCheck.9bd6635e.svg";